import type { PDPStoreApi } from '@/scopes/products/infrastructure/store'
import { AnchorHref } from '@/scopes/products/pages/components/AnchorMenu/types'

interface PDPUseCasesDependencies {
  store: PDPStoreApi
}

const UPPER_INTERSECTION_PADDING = 40

export function pdpUseCases({ store }: PDPUseCasesDependencies) {
  function onAnchorTargetIntersects({
    anchorHref,
    isIntersecting,
    anchorTopPositions,
  }: {
    anchorHref: AnchorHref
    isIntersecting: boolean
    anchorTopPositions: Record<string, number>
  }) {
    const state = store.getState()

    let intersectingAnchors
    const currentAnchorTargetsIntersecting = state.anchorsTargetIntersecting
    if (isIntersecting) {
      intersectingAnchors = removeAnchorTargetFrom(currentAnchorTargetsIntersecting, anchorHref)
      intersectingAnchors = [...intersectingAnchors, anchorHref]
    }
    else {
      intersectingAnchors = removeAnchorTargetFrom(currentAnchorTargetsIntersecting, anchorHref)
    }

    let activeAnchorHref = AnchorHref.General
    let closestDistance: number
    intersectingAnchors.forEach((anchorElement) => {
      const anchorTopPosition = anchorTopPositions[anchorElement]
      const anchorIsBelowTopOfViewport = anchorTopPosition >= 0
      let absoluteAnchorPosition = Math.abs(anchorTopPosition)

      if (anchorIsBelowTopOfViewport) {
        const absolutePostionWithPadding = absoluteAnchorPosition - UPPER_INTERSECTION_PADDING
        absoluteAnchorPosition = Math.abs(absolutePostionWithPadding)
      }

      if (!closestDistance) {
        closestDistance = absoluteAnchorPosition
      }

      if (absoluteAnchorPosition <= closestDistance) {
        closestDistance = absoluteAnchorPosition
        activeAnchorHref = anchorElement
      }
    })

    state.setIn('activeAnchorHref', activeAnchorHref)
    state.setIn('anchorsTargetIntersecting', intersectingAnchors)
  }

  return {
    onAnchorTargetIntersects,
  }
}

function removeAnchorTargetFrom(currentAnchorTargetsIntersecting: AnchorHref[], anchorHref: AnchorHref) {
  return currentAnchorTargetsIntersecting.filter(item => item !== anchorHref)
}
